import "./loading.css";

export const Loading = () => {
  return (
    <div className="loading-view h-screen">
      <div className="w-16 h-16">
        <img
          src="/img/Vector.svg"
          className="fill-animation object-contain w-full h-full"
          alt="loading logo"
        />
      </div>
    </div>
  );
};
